export default __webpack_public_path__ + "static/media/CrowdfundingVariable.b4ee0619.svg";